import { render, staticRenderFns } from "./SaleSite.vue?vue&type=template&id=9a45d8a8&scoped=true"
import script from "./SaleSite.vue?vue&type=script&lang=js"
export * from "./SaleSite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a45d8a8",
  null
  
)

export default component.exports